export default {
    RefundOnlyToBeReviewed: {
        OrderNo: 'Refund order/sales Order No.',
        Document: 'Refund order source',
        Refundtype: 'Refund order type',
        Nickname: "Buyer's nickname",
        Refund: 'Refund time',
        Approved: 'Approved',
        Approval: 'Rejected',
        form: {
            Third: 'Third-party refund Order No.',
            Refund: 'Internal refund Order No.',
            party: 'Customer Order No.',
            PlatformOrder: 'Platform Order No.',
            Order: 'CSG Order No.',
            timeout: 'Pre-authorization timeout',
            exception: 'Push timeout',
            loss: 'Data Anomaly',
            Stock: 'Order Out-of-Stock',
            Preemption: 'Preemption',
            ReturnMessage: 'Return message',
            Refundtype: 'Refund order type',
            Type: 'Refund type',
            Source: 'Refund order source',
            status: 'Status',
            Approval: 'Review status',
            quantity: 'Refund quantity',
            Total: 'Total refund amount to be paid',
            reason: 'Refund reason',
            comments: "Buyer's remarks",
            service: 'CSG Comments',
            nickname: "Buyer's nickname",
            store: 'Store',
            channel: 'Sales Channel',
            Three: 'Third-party refund time',
            creation: 'Internal Creation Time',
            Completion: 'Completion time',
        },
    }
};
